<template>
  <span>
    <v-dialog
      v-model="getModalPesquisarProdutosOrcamento"
      max-width="960px"
      fullscreen
    >
      <v-card>
        <v-card-title
          >Pesquisar Produto
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click="setModalPesquisarProdutosOrcamento(false)"
            float-right
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-title>
          <v-btn-toggle rounded>
            <v-btn @click="tipoListagem = 'lista'">
              <v-icon>dehaze</v-icon>
            </v-btn>
            <v-btn @click="tipoListagem = 'grade'">
              <v-icon>view_comfy</v-icon>
            </v-btn>
          </v-btn-toggle>
          <v-spacer></v-spacer>
          Produtos: {{ getProdutos.total }} -
          <v-pagination
            outlined
            total-visible="7"
            v-model="getProdutos.current_page"
            :length="getProdutos.last_page"
            @input="visualizarPagina($event)"
          ></v-pagination>
          <!-- <v-layout row wrap>
            <v-flex xs1 md3 class="ml-2">
              
            </v-flex>
            <v-flex xs12 md6>
              <span class="float-right title mr-10 ml-1"
                ><h5>
                  Página: {{ getProdutos.current_page }} de
                  {{ getProdutos.last_page }}
                </h5></span
              >
              <span class="float-right title mr-1 ml-1"
                ><h5>Produtos: {{ getProdutos.total }} -</h5>
              </span>
            </v-flex>
            <v-flex xs12 md2>
              <v-icon
                class="mr-1 ml-1"
                v-if="getProdutos.current_page > 1"
                @click="visualizarPagina(1)"
              >
                mdi-arrow-collapse-left</v-icon
              >
              <v-icon
                class="mr-1 ml-1"
                v-if="getProdutos.current_page > 1"
                @click="visualizarPagina(getProdutos.current_page - 1)"
                >keyboard_arrow_left</v-icon
              >
              <v-icon
                class="mr-1 ml-1"
                v-if="getProdutos.current_page < getProdutos.last_page"
                @click="visualizarPagina(getProdutos.current_page + 1)"
                >keyboard_arrow_right</v-icon
              >
              <v-icon
                class="mr-1 ml-1"
                v-if="getProdutos.current_page < getProdutos.last_page"
                @click="visualizarPagina(getProdutos.last_page)"
                >mdi-arrow-collapse-right</v-icon
              >
            </v-flex>
          </v-layout> -->
        </v-card-title>
        <v-card-text v-if="tipoListagem == 'lista'">
          <v-progress-linear
            indeterminate
            color="cyan"
            v-if="getOverlay"
          ></v-progress-linear>
          <v-simple-table dense fixed-header>
            <template v-slot:default>
              <thead>
                <tr>
                  <th width="8%" class="text-left">
                    <v-text-field
                      v-model="dataPagina.id"
                      label="Código"
                      outlined
                      dense
                      class="mt-2"
                      autocomplete="new-codigo"
                      @input="debouncePesquisarProdutos()"
                      @keyup.enter="
                        selecionarProduto(
                          getProdutos.data[indexLinhaSelecionadaTabela]
                        )
                      "
                      type="number"
                    ></v-text-field>
                  </th>
                  <th class="text-left">
                    <v-text-field
                      v-model="dataPagina.descricao"
                      label="Descrição"
                      outlined
                      dense
                      class="mt-2"
                      autocomplete="new-descricao"
                      @input="debouncePesquisarProdutos()"
                      id="inputValorPesquisa"
                      @keyup.enter="
                        selecionarProduto(
                          getProdutos.data[indexLinhaSelecionadaTabela]
                        )
                      "
                    ></v-text-field>
                  </th>
                  <th class="text-left" v-if="exibirPrecoCusto">Preço Custo</th>
                  <th class="text-left">Preço de Venda</th>
                  <th width="15%" class="text-left">
                    <v-text-field
                      label="Marca"
                      class="mt-2"
                      v-model="dataPagina.marca"
                      outlined
                      dense
                      autocomplete="new-marca"
                      @input="debouncePesquisarProdutos()"
                      @keyup.enter="
                        selecionarProduto(
                          getProdutos.data[indexLinhaSelecionadaTabela]
                        )
                      "
                    ></v-text-field>
                  </th>

                  <th width="10%" class="text-left">
                    <v-autocomplete
                      v-model="dataPagina.estoque_id"
                      :items="getEstoques"
                      label="Estoque"
                      item-text="nome"
                      item-value="id"
                      outlined
                      dense
                      class="mt-2"
                      autocomplete="new-estoque"
                      @input="debouncePesquisarProdutos()"
                      @keyup.enter="
                        selecionarProduto(
                          getProdutos.data[indexLinhaSelecionadaTabela]
                        )
                      "
                    ></v-autocomplete>
                  </th>

                  <th width="8%">
                    <v-select
                      dense
                      outlined
                      :items="resultadosPorPagina"
                      item-value="value"
                      item-text="label"
                      v-model="limitePorPagina"
                      label="Exibir"
                      @change="visualizarPagina(getProdutos.current_page)"
                      class="mt-2"
                    ></v-select>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(i, key) in getProdutos.data"
                  :key="i.id"
                  @click="selecionarProduto(i)"
                  :class="
                    indexLinhaSelecionadaTabela == key ? 'linhaSelecionada' : ''
                  "
                >
                  <td align="center">{{ i.id }}</td>
                  <td>{{ i.descricao }}</td>
                  <td v-if="exibirPrecoCusto">
                    {{ $helper.formatReal(parseFloat(i.preco_custo)) }}
                  </td>
                  <td>{{ $helper.formatReal(parseFloat(i.preco_venda)) }}</td>
                  <td>{{ i.marca }}</td>
                  <td width="10%" v-if="i.estoque[0]" align="center">
                    <v-chip :color="getCorSituacaoEstoque(i)" small dark>
                      {{ i.estoque[0].quantidade }}
                    </v-chip>
                  </td>
                  <td align="center" v-else>
                    <v-chip color="#E53935" small dark> 0 </v-chip>
                  </td>
                  <td>
                    <v-btn
                      color="primary"
                      x-small
                      @click="selecionarProduto(i)"
                      outlined
                      >Adicionar
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-card-text>
        <v-card-text v-if="tipoListagem == 'grade'">
          <v-fade-transition mode="out-in">
            <v-row>
              <v-col
                cols="3"
                v-for="i in getProdutos.data"
                :key="i.id"
                @click="selecionarProduto(i)"
              >
                <v-card outlined>
                  <v-img
                    :src="i.url_foto"
                    max-height="125"
                    contain
                    class="grey darken-4"
                    v-if="i.url_foto"
                  ></v-img>
                  <v-img
                    v-if="!i.url_foto"
                    src="/img/sem-imagem.jpg"
                    max-height="125"
                    contain
                    class="grey darken-4"
                  ></v-img>
                  <v-card-title class="title">
                    {{ i.id }} - {{ i.descricao }}
                  </v-card-title>
                  <v-card-text>
                    Preço de Venda: R$
                    {{ $helper.formatReal(parseFloat(i.preco_venda)) }} <br />
                    Marca: {{ i.marca }} <br />
                  </v-card-text>
                  <v-card-actions>
                    <v-btn
                      color="success"
                      @click="selecionarProduto(i)"
                      block
                      outlined
                      small
                    >
                      Adicionar</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>
          </v-fade-transition>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <h3>Produtos: {{ getProdutos.total }} -</h3>
          <v-pagination
            outlined
            total-visible="7"
            v-model="getProdutos.current_page"
            :length="getProdutos.last_page"
            @input="visualizarPagina($event)"
          ></v-pagination>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
var _ = require("lodash");
export default {
  props: {
    exibirPrecoCusto: false,
  },
  data() {
    return {
      pesquisando: false,
      valorPesquisa: "",
      campoPesquisa: "descricao",
      quantidade: 0,
      total: 0.0,
      limitePorPagina: 20,
      dataPagina: {
        page: 1,
        query: {
          campo: "descricao",
          valor: "",
        },
        codigo: "",
        descricao: "",
        estoque_id: 1,
        marca: "",
      },
      indexLinhaSelecionadaTabela: 0,
      resultadosPorPagina: [
        {
          label: "10",
          value: 10,
        },
        {
          label: "20",
          value: 20,
        },
        {
          label: "30",
          value: 30,
        },
        {
          label: "40",
          value: 40,
        },
        {
          label: "50",
          value: 50,
        },
      ],
      camposPesquisa: [
        {
          label: "Codigo de Barras",
          value: "codigo_barra",
        },
        {
          label: "Descrição",
          value: "descricao",
        },
        {
          label: "Código",
          value: "id",
        },
        {
          label: "Marca",
          value: "marca",
        },
      ],
      modalAdicionarProduto: false,
      tipoListagem: "lista",
    };
  },
  computed: {
    ...mapGetters([
      "getModalPesquisarProdutosOrcamento",
      "getProdutos",
      "getProduto",
      "getOrcamento",
      "getOverlay",
      "getEstoques",
    ]),
  },
  watch: {
    valorPesquisa() {
      this.debouncePesquisarProdutos();
    },
    quantidade() {
      this.somaTotalItem();
    },
    getModalPesquisarProdutosOrcamento() {
      if (this.getModalPesquisarProdutosOrcamento) {
          (this.dataPagina.id = ""),
          (this.dataPagina.descricao = ""),
          (this.dataPagina.estoque_id = 1),
          (this.dataPagina.marca = ""),
          (this.dataPagina.pagina = this.pagina);
          this.dataPagina.limite = 20;
        setTimeout(() => {
          this.listarProdutos(this.dataPagina);
        }, 100);
      }

      setTimeout(() => {
        this.focusValorPesquisa();
      }, 100);
    },
  },
  methods: {
    ...mapActions([
      "setModalPesquisarProdutosOrcamento",
      "pesquisarProduto",
      "buscarProduto",
      "produtoVisualizarPagina",
      "listarProdutos",
      "listarEstoque",
    ]),
    getEstoquePrincipal(item) {
      if (item.estoque[0]) {
        return estoque[0].quantidade;
      } else {
        return "0.00";
      }
    },
    visualizarPagina(pagina) {
      this.dataPagina.pagina = pagina;
      this.dataPagina.path = this.getProdutos.path;
      this.dataPagina.limite = this.limitePorPagina;
      this.listarProdutos(this.dataPagina);
    },
    pesquisarProdutos() {
      this.dataPagina.path = `${process.env.VUE_APP_URL_API}/v1/produtos`;
      this.dataPagina.query.campo = this.campoPesquisa;
      this.dataPagina.query.valor = this.valorPesquisa;
      this.dataPagina.limite = this.limitePorPagina;
      this.listarProdutos(this.dataPagina);
    },
    selecionarProduto(item) {
      this.$emit("focusInputQuantidade");
      const produto = { ...item };
      produto.preco_venda = this.$helper.formatReal(
        parseFloat(item.preco_venda)
      );
      produto.preco_custo = this.$helper.formatReal(
        parseFloat(item.preco_custo)
      );

      this.$store.commit("setProdutoVenda", produto);

      this.$store.commit("setProduto", produto);

      this.setModalPesquisarProdutosOrcamento(false);

      this.somaTotalItem();
    },
    somaTotalItem() {
      this.total =
        parseFloat(this.quantidade) * parseFloat(this.getProduto.preco_venda);
    },
    getCorSituacaoEstoque(item) {
      if (item.estoque[0] && item.estoque[0].quantidade <= 0) {
        return "#E53935";
      } else if (
        item.estoque[0] &&
        item.estoque[0].quantidade <= item.estoque_minimo &&
        item.estoque[0].quantidade > 0
      ) {
        return "#F9A825";
      } else if (!item.estoque[0]) {
        return "#E53935";
      } else {
        return "#039BE5";
      }
    },
    focusValorPesquisa() {
      document.getElementById("inputValorPesquisa").focus();
    },
    keyUp(e) {
      if (!e) e = window.event;
      let keyCode = e.keyCode || e.which;
      if (keyCode == 40) e.preventDefault();
      if (keyCode == 38) e.preventDefault();

      if (keyCode == 40) {
        if (
          this.indexLinhaSelecionadaTabela <
          this.getProdutos.data.length - 1
        ) {
          this.indexLinhaSelecionadaTabela++;
        }
      }

      if (keyCode == 38) {
        if (this.indexLinhaSelecionadaTabela >= 1) {
          this.indexLinhaSelecionadaTabela -= 1;
        }
      }
    },
  },
  mounted() {
    this.valorPesquisa = "";
  },
  created() {
    document.addEventListener("keydown", this.keyUp);
    this.listarEstoque();
    this.debouncePesquisarProdutos = _.debounce(this.pesquisarProdutos, 300);
    //this.listarProdutos(this.dataPagina);
  },
};
</script>

<style>
.linhaSelecionada {
  background-color: #e2e2e2;
}
</style>
